import { jwtDecode } from 'jwt-decode'

const get_tokens = async (base_url, clientId, clientSecret, auth_code, redirect_uri, codeVerifier) => {
    // This is the token endpoint we will use to exchange the Authorization Code for an Access Token and Identity Token.
    const token_url = `${base_url}/a/consumer/api/v0/oidc/token`

    try {
        // Validate required parameters
        if (!base_url) throw new Error('Base URL is required');
        if (!clientId) throw new Error('Client ID is required');
        if (!clientSecret) throw new Error('Client Secret is required');
        if (!auth_code) throw new Error('Authorization code is required');
        if (!redirect_uri) throw new Error('Redirect URI is required');
        if (!codeVerifier) throw new Error('Code verifier is required');

        
        // Construct the request body
        const requestBody = new URLSearchParams({
            client_id: clientId,
            client_secret: clientSecret,
            grant_type: 'authorization_code',
            code: auth_code,
            redirect_uri: redirect_uri,
            code_verifier: codeVerifier
        }).toString();

        

        // Send a request to the token endpoint to receive the authenticated payload
        const auth_response = await fetch(token_url, {
            method: 'post',
            headers: { 
                'Content-Type': 'application/x-www-form-urlencoded'
            }, 
            body: requestBody
        });

        // Log response status and headers
        

        if (!auth_response.ok) {
            const errorText = await auth_response.text();
            
            throw new Error(`Token request failed with status ${auth_response.status}: ${errorText}`);
        }

        // Parse and decode the response to get an Access Token and Identity Token
        const token_response = await auth_response.text();
        
        
        let parsedResponse;
        try {
            parsedResponse = JSON.parse(token_response);
        } catch (e) {
            
            throw new Error('Invalid token response format');
        }

        if (!parsedResponse.access_token || !parsedResponse.id_token) {
            
            throw new Error('Missing required tokens in response');
        }

        const access_token = parsedResponse.access_token;
        const id_token = parsedResponse.id_token;

        // Validate tokens before decoding
        if (typeof id_token !== 'string') {
            
            throw new Error('ID token must be a string');
        }

        let id_token_decoded;
        try {
            id_token_decoded = jwtDecode(id_token);
            
        } catch (e) {
            
            throw new Error('Failed to decode ID token: ' + e.message);
        }

        // Validate decoded token
        if (!id_token_decoded || typeof id_token_decoded !== 'object') {
            
            throw new Error('Invalid decoded token format');
        }

        
        return {
            access_token: access_token,
            id_token: id_token_decoded
        };
    } catch (error) {
        
        throw error;
    }
}

export default get_tokens